import toDate from "../toDate/index.js";
import requiredArgs from "../_lib/requiredArgs/index.js";
export default function isWithinInterval(dirtyDate, interval) {
    requiredArgs(2, arguments);
    var time = toDate(dirtyDate).getTime();
    var startTime = toDate(interval.start).getTime();
    var endTime = toDate(interval.end).getTime();
    if (!(startTime <= endTime)) {
        throw new RangeError('Invalid interval');
    }
    return time >= startTime && time <= endTime;
}
